import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[cmgClear2UiReadOnlyValidation]',
})
export class ReadOnlyValidationDirective {
  private readonly _el = inject(ElementRef);

  constructor() {
    // Set the background of this element to grey
    // NOTE: a CSS rule using the selector "[cmgClear2UiReadOnlyValidation]" might be needed for child elements background
    this._el.nativeElement.style.backgroundColor = 'rgb(238, 238, 238)';

    // Disable any user input without using "readonly" or "disabled" attributes
    this._el.nativeElement.setAttribute('autocomplete', 'off');
    this._el.nativeElement.addEventListener('keydown', function (event) {
      event.preventDefault();
    });
    this._el.nativeElement.addEventListener('contextmenu', function (event) {
      event.preventDefault();
    });
    this._el.nativeElement.addEventListener('paste', function (event) {
      event.preventDefault();
    });
  }
}
